/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { NameValue } from '../tool/name-value';
import { CommonUtils } from '../tool/common-utils';

export class SearchTag extends NameValue {
  public get type(): 'date' | 'string' {
    return this.value instanceof Date ? 'date' : 'string';
  }
  public label: string;
  public required: boolean;
  public tooltip: string;

  constructor(id: string, label: string, value: any, required?: boolean) {
    super(id, value);
    this.label = label;
    this.required = required;
    if (value instanceof Date) {
      this.tooltip = CommonUtils.convertDateToString(value);
    } else {
      this.tooltip = value;
    }
  }
}
